import { render } from "./EditChapter.vue?vue&type=template&id=3c2a737e"
import script from "./EditChapter.vue?vue&type=script&lang=js"
export * from "./EditChapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__